import React, { Component } from "react";
import {
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@material-ui/core/";

import { Subscriptions } from "./Subscriptions";

class ManageClient extends Component {
  constructor(props) {
    super(props);
    this.state = {
      migrated: false
    };
  }

  componentDidMount() {
  }

  render() {
    const { client } = this.props;

    console.log("MigrateClient", this.props);

    return (
      <div style={{ padding: 16, margin: "auto" }}>
        <Typography
          component="h2"
          variant="h6"
          color="primary"
          gutterBottom
          style={{ textAlign: "center" }}
        >
          Manage Client
        </Typography>
        <List>
          <ListItem>
            <ListItemText
              disableTypography
              primary={
                <Typography
                  type="body2"
                  style={{ fontSize: 20, fontWeight: 600 }}
                >
                  {client.name}
                </Typography>
              }
              secondary={
                <Typography type="body2" style={{ fontSize: 16 }}>
                  {"ClientId: " + client.id + " - StripeId: " + client.stripeId}
                </Typography>
              }
            />
          </ListItem>
        </List>
        <Subscriptions client={client} />
      </div>
    );
  }
}

export { ManageClient };
